import type { PlatformId } from '@kirin/api-client/contracts/platform-registry';

/**
 * KIR-5139: the Claude Desktop hook (Cowork / cloud session) runs in a VM, so
 * its occurrences never carry an endpoint of the user's. Shown in place of
 * "No endpoint recorded" / "—".
 */
export const CLOUD_SESSION_CLIENT_TYPE: PlatformId = 'claude_desktop_hook';
export const CLOUD_SESSION_LABEL = 'Cloud session';
export const CLOUD_SESSION_TITLE =
  "Ran in a Claude cloud / Cowork session VM, not on one of the user's endpoints";
